import { useEffect, useState } from "react";
import styles from "./AdminDashboard.module.css";
import { c7Api } from "../../../Logic/c7Api";
import AdminVideos from "./AdminVideos";

interface CursoUsuario {
  id: number;
  UsuarioID: number;
  CursoID: number;
  PuedeEntrar: number;
  FechaActivacion: string | null;
  Periodo: string;
  usuario: {
    UsuarioID: number;
    Email: string;
     persona: {
      Nombre: string;
      Apellido: string;
    };
  };
}

const AdminDashboard = () => {
  const [usuarios, setUsuarios] = useState<CursoUsuario[]>([]);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("token");

const fetchUsuarios = async () => {
  try {
    setLoading(true);

    const response = await fetch(
      c7Api.getBaseUrl() + "/api/admin/curso-usuarios",
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );

    const data = await response.json();
    setUsuarios(data);
  } catch (error) {
    console.error("Error al refrescar usuarios", error);
  } finally {
    setLoading(false);
  }
};


const toggleAcceso = async (id: number, estadoActual: number, periodo: string) => {
  try {
    await fetch(
      c7Api.getBaseUrl() + `/api/admin/curso-usuarios/${id}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          PuedeEntrar: estadoActual === 1 ? 0 : 1,
          Periodo: periodo
        }),
      }
    );

 
    fetchUsuarios();
  } catch (error) {
    console.error("Error al cambiar acceso", error);
  }
};

  useEffect(() => {
    fetchUsuarios();
  }, []);



 return (
  <div className={styles.container}>
       <h2 className={styles.title}>Agregar Lecciones</h2>
         <AdminVideos></AdminVideos>
    <h2 className={styles.title}>Usuarios del Curso</h2>

    {loading && <p>Cargando usuarios...</p>}

    {!loading && (
      <>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Email</th>
              <th>Periodo</th>
              <th>Acceso</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            {usuarios.map((u) => (
              <tr key={u.id}>
                    <td>{u.usuario.persona.Nombre} {u.usuario.persona.Apellido}</td>
                <td>{u.usuario.Email}</td>
                    <td><select value={u.Periodo} onChange={(e) => toggleAcceso(u.id, (u.PuedeEntrar === 1 ? 0 : 1), e.target.value)}>
                      <option value="Enero 2026">Enero 2026</option>
                      <option value="Abril 2026">Abril 2026</option>
                    </select></td>
                <td
                  className={
                    u.PuedeEntrar === 1
                      ? styles.permitido
                      : styles.bloqueado
                  }
                >
                  {u.PuedeEntrar === 1 ? "Permitido" : "Bloqueado"}
                </td>
                <td>
                  <button
                    onClick={() => toggleAcceso(u.id, u.PuedeEntrar, u.Periodo)}
                    className={
                      u.PuedeEntrar === 1
                        ? styles.btnBloquear
                        : styles.btnPermitir
                    }
                  >
                    {u.PuedeEntrar === 1 ? "Bloquear" : "Permitir"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </>
    )}

    {/* 🔄 BOTÓN SIEMPRE VISIBLE */}
    <div className={styles.refreshContainer}>
      <button
        className={styles.refreshButton}
        onClick={fetchUsuarios}
        disabled={loading}
      >
        {loading ? "Actualizando..." : "Refrescar"}
      </button>
    </div>
  </div>
);

};

export default AdminDashboard;
